import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NetworkError = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const tryAgain = () => {
    window.onbeforeunload = null;
    window.location.replace(location.state.path);
  };

  return (
    <div className="my-auto w-full md:mx-[5rem] xl:mx-[10rem] z-50">
      <div className="m-auto bg-white md:rounded-md w-full md:shadow-md px-4 py-[6rem]">
        <svg
          width="102"
          height="102"
          viewBox="0 0 102 102"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="m-auto"
        >
          <path
            d="M50.7956 25.0137C66.1639 25.2521 78.9885 31.0818 89.087 42.7425C90.4661 44.3348 90.2977 46.5444 88.7585 47.8655C87.2913 49.1258 85.1097 48.9657 83.7613 47.4C80.0895 43.1375 75.8332 39.6075 70.8465 36.9904C55.2091 28.7841 36.5052 30.7959 23.034 42.1931C21.1775 43.7638 19.5258 45.5861 17.8516 47.3601C16.4019 48.8972 14.2637 49.1433 12.7307 47.8229C11.2174 46.5192 11.1028 44.2985 12.4833 42.6985C20.9461 32.8894 31.5954 27.0904 44.4298 25.3178C45.435 25.1787 46.4485 25.071 47.4614 25.0249C48.5707 24.9753 49.6842 25.0137 50.7956 25.0137Z"
            fill="#DEDEDE"
          />
          <path
            d="M52.066 39.2637C61.7801 39.5153 70.9118 43.6646 78.0983 51.9687C79.5152 53.6065 79.3488 55.7203 77.7761 57.0722C76.2781 58.359 74.1098 58.1857 72.7265 56.5836C68.9777 52.2435 64.4321 49.0595 58.8918 47.5636C47.6001 44.5153 37.8371 47.2952 29.6609 55.6532C29.3568 55.9642 29.0765 56.2984 28.7871 56.6234C27.4381 58.1437 25.2551 58.3471 23.7802 57.0903C22.2249 55.7657 22.0634 53.5758 23.4237 51.9722C26.6258 48.1976 30.4382 45.1954 34.8734 42.9943C39.9006 40.4995 45.2284 39.2867 52.066 39.2637Z"
            fill="#DEDEDE"
          />
          <path
            d="M68.0471 63.5665C68.0457 65.0456 67.1516 66.3542 65.7767 66.8903C64.392 67.4299 62.8549 67.0707 61.8183 65.897C60.2909 64.167 58.5294 62.7683 56.3933 61.8631C50.5615 59.3921 44.1279 60.9271 39.7906 65.8257C38.7623 66.9875 37.4783 67.409 35.995 66.9588C34.5676 66.5261 33.7442 65.4979 33.524 64.0258C33.3688 62.9885 33.6813 62.0665 34.3481 61.2626C41.7757 52.3063 55.4406 51.0383 64.3766 58.5044C65.3923 59.353 66.3464 60.3022 67.1866 61.3221C67.6808 61.9218 67.894 62.7529 68.233 63.4806C68.1715 63.5092 68.1093 63.5379 68.0471 63.5665Z"
            fill="#DEDEDE"
          />
          <path
            d="M50.7838 82.2241C46.7988 82.2262 43.6344 79.0646 43.6372 75.0838C43.6393 71.1666 46.8226 67.9813 50.7524 67.9659C54.6996 67.9505 57.9032 71.1624 57.8927 75.1251C57.8829 79.0709 54.7269 82.222 50.7838 82.2241Z"
            fill="#DEDEDE"
          />
          <path
            d="M50.8287 0.11377C22.8015 0.11377 0 22.9152 0 50.9418C0 78.969 22.8015 101.77 50.8287 101.77C78.8552 101.77 101.657 78.969 101.657 50.9418C101.657 22.9152 78.8552 0.11377 50.8287 0.11377ZM6.99003 50.9418C6.99003 26.7695 26.6565 7.1038 50.8287 7.1038C62.2378 7.1038 72.6397 11.4879 80.4468 18.6562L18.5431 80.5606C11.3749 72.7534 6.99003 62.3516 6.99003 50.9418ZM50.8287 94.7804C40.5778 94.7804 31.1455 91.2344 23.671 85.3173L85.2042 23.7848C91.1206 31.2585 94.6666 40.6909 94.6666 50.9418C94.6666 75.1147 75.0016 94.7804 50.8287 94.7804Z"
            fill="#EDEDED"
          />
        </svg>
        <p className="text-[1.5rem] font-semibold text-center mt-[2rem] mb-2">
          {t('errors.network_error.header')}
        </p>
        <p className="text-[#7B7B7B] text-center">
          {t('errors.network_error.subHeader')}
        </p>
        <button
          type="button"
          className="flex justify-center font-semibold rounded-md py-3 text-center border-2 mt-[2rem] w-max px-[6.5rem] m-auto bg-white border-button"
          onClick={tryAgain}
          id="try_again"
        >
          {t('errors.network_error.button')}
        </button>
      </div>
    </div>
  );
};

export default NetworkError;
